<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Unidades de Medida</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/configuracoes/cadastros">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Gerenciamento de unidades de medida.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">

                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) {
                    <span>Ações ({{selection.selected.length}})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <mat-menu #opcoesMenu="matMenu">
                    <button mat-menu-item (click)="abrirModalExcluir()" [disabled]="!selection.hasValue()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir selecionados</span>
                    </button>
                </mat-menu>

                <button type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/cadastros/unidades-medida/cadastrar">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Nova Unidade
                </button>
            </div>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" formControlName="pesquisa"
                            placeholder="Busque pelo nome da unidade de medida...">

                        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if(_isLoading && _dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if(_dataSource.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()" [disabled]="isToggleAllDisabled()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    @if (isSelecaoBloqueada(row)) {
                    <span class="row-lock-wrapper">
                        <span class="material-symbols-outlined row-lock-icon"
                            [matTooltip]="getTooltipSelecaoBloqueada(row)">
                            lock
                        </span>
                    </span>
                    } @else {
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Unidade de Medida </th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex justify-content-between align-items-center">
                        <span>{{element.abreviacao}} - {{element.descricao}}</span>
                        <div class="d-flex align-items-center gap-2">
                            @if (element.isFracionada) {
                            <span class="status-badge badge-azul">Fracionada</span>
                            }
                            @if (element.isPadrao) {
                            <span class="status-badge badge-cinza">Padrão</span>
                            }
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <div [matTooltip]="getTooltipMessage(element)" matTooltipPosition="left">
                        <button mat-icon-button [matMenuTriggerFor]="element.isPadrao ? null : menu" aria-label="Ações"
                            [disableRipple]="element.isPadrao" [style.color]="element.isPadrao ? '#d0d0d0' : null"
                            [style.cursor]="element.isPadrao ? 'default' : 'pointer'">
                            <span class="material-symbols-outlined">more_horiz</span>
                        </button>
                    </div>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/cadastros/unidades-medida/cadastrar', element.idUnidadeMedida]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <span class="menu-action-tooltip-wrapper"
                            [matTooltip]="getTooltipExcluir(element)"
                            [matTooltipDisabled]="!isSelecaoBloqueada(element)">
                            <button mat-menu-item (click)="abrirModalExcluir(element)"
                                [disabled]="isSelecaoBloqueada(element)">
                                <span class="material-symbols-outlined">delete</span>
                                <span>Excluir</span>
                            </button>
                        </span>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
        </table>


        <div class="mobile-view">
            @for (item of _dataSource.data; track item.idUnidadeMedida) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        @if (isSelecaoBloqueada(item)) {
                        <span class="material-symbols-outlined row-lock-icon"
                            [matTooltip]="getTooltipSelecaoBloqueada(item)">
                            lock
                        </span>
                        } @else {
                        <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                            [checked]="selection.isSelected(item)" color="primary">
                        </mat-checkbox>
                        }
                        <span class="text-bold">{{item.abreviacao}} - {{item.descricao}}</span>
                        @if (item.isPadrao) {
                        <span class="status-badge badge-cinza">Padrão</span>
                        }
                        @if (item.isFracionada) {
                        <span class="status-badge badge-azul">Fracionada</span>
                        }
                    </div>
                    <div [matTooltip]="getTooltipMessage(item)" matTooltipPosition="before">
                        <button mat-icon-button [matMenuTriggerFor]="item.isPadrao ? null : menuMobile"
                            [disableRipple]="item.isPadrao" [style.color]="item.isPadrao ? '#d0d0d0' : null"
                            [style.cursor]="item.isPadrao ? 'default' : 'pointer'">
                            <span class="material-symbols-outlined">more_horiz</span>
                        </button>
                    </div>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/cadastros/unidades-medida/cadastrar', item.idUnidadeMedida]">Editar</button>
                        <span class="menu-action-tooltip-wrapper"
                            [matTooltip]="getTooltipExcluir(item)"
                            [matTooltipDisabled]="!isSelecaoBloqueada(item)">
                            <button mat-menu-item (click)="abrirModalExcluir(item)"
                                [disabled]="isSelecaoBloqueada(item)">Excluir</button>
                        </span>
                    </mat-menu>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
            <button mat-button class="btn-ver-mais"
                [disabled]="_isLoading || _dataSource.data.length >= _totalRegistros" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="20"></mat-spinner>
                }
                @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>

        } @else {
        <app-empty-list [title]="'Nenhuma unidade de medida encontrada'"
            [subTitle]="'Adicione uma nova unidade de medida para começar'"></app-empty-list>
        }
    </div>
</div>
